import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GrupoService } from 'src/app/services/grupo.service';
import { CategoriaService } from 'src/app/services/categoria.service';

@Component({
  selector: 'app-grupo-edit-modal',
  template: `
  <form>
    <div class="modal-header">
      <h4 class="modal-title">Editar grupo</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-row">
        <div class="form-group col-md-7">
          <input type="text" class="form-control" [(ngModel)]="nome" [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-group col-md-12">
          <select id="inputCategoria" class="form-control" [(ngModel)]="id_categoria" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let categoria of arrCategorias" [value]="categoria.id">{{categoria.category}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="activeModal.dismiss('cancel click')">Cancelar</button>
      <button type="button" (click)="edit(nome, id, id_categoria)" class="btn btn-danger" ngbAutofocus>Editar</button>
    </div>
  </form>
  `
})
export class ModalGrupoEditComponent {
  @Input() nome;
  @Input() id;
  @Input() id_categoria;
  @Input() arrCategorias;

  constructor(public activeModal: NgbActiveModal) {}

  edit(nome, id, id_categoria) {
    const data = {
      id: id,
      nome: nome,
      id_categoria: id_categoria
    };
    this.activeModal.close(data);
  }
}

@Component({
  selector: 'app-grupo',
  templateUrl: './grupo.component.html',
  styleUrls: ['./grupo.component.css']
})
export class GrupoComponent implements OnInit {

  statusForm: any;
  loading = false;
  arrItems: any;
  arrCategorias: any;
  id: any;

  constructor(private notify: SnotifyService,
    private Grupo: GrupoService,
    private Categoria: CategoriaService,
    private modalService: NgbModal) {
      this.getForm();
  }

  getForm() {
    this.statusForm = new FormGroup({
      nome: new FormControl(''),
      selectedCategoria: new FormControl(0),
    });
  }

  ngOnInit() {
    this.loading = true;
    this.Grupo.grupo().subscribe(
      result => {
        this.loading = false;
        this.arrItems = result;
      },
      error => {
        this.loading = false;
        this.notify.error('Erro ao retornar o grupo', {timeout: 3000, showProgressBar: false });
      }
    );

    this.Categoria.categoria().subscribe(
      result => {
        this.loading = false;
        this.arrCategorias = result;
      },
      error => {
        this.loading = false;
        this.notify.error('Erro ao retornar a categoria', {timeout: 3000, showProgressBar: false });
      }
    );
  }

  checkButton() {
    return this.statusForm.value.nome;
  }

  openRemove(content, id) {
    this.id = id;
    this.modalService.open(content);
  }

  openEdit(id, nome, id_categoria) {
    const modalRef = this.modalService.open(ModalGrupoEditComponent);
    modalRef.componentInstance.nome = nome;
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.categoryId = id_categoria;
    modalRef.componentInstance.arrCategorias = this.arrCategorias;

    modalRef.result.then((result) => {
      this.edit(result);
    }).catch((error) => {
    });
  }

  edit(data) {
    this.Grupo.edit(data).subscribe(
      result => {
        this.loading = false;
        this.arrItems = result['data'];
        this.modalService.dismissAll();
        this.notify.success(result['message'], {timeout: 2000, showProgressBar: false });
      },
      error => {
        this.loading = false;
        this.modalService.dismissAll();
        this.notify.error(error.error, {timeout: 3000, showProgressBar: false });
      }
    );
  }

  onSubmit() {
    this.loading = true;
    this.Grupo.save(this.statusForm.value).subscribe(
      result => {
        this.loading = false;
        this.statusForm.reset();
        this.arrItems = result['data'];
        this.notify.success(result['message'], {timeout: 2000, showProgressBar: false });
      },
      err => {
        this.loading = false;
        this.statusForm.reset();
        this.notify.error(err.error.error, {timeout: 3000, showProgressBar: false });
      }
    );
  }

  remove() {
    this.Grupo.remove(this.id).subscribe(
      result => {
        this.loading = false;
        this.arrItems = result['data'];
        this.modalService.dismissAll();
        this.notify.success(result['message'], {timeout: 2000, showProgressBar: false });
      },
      err => {
        this.loading = false;
        this.modalService.dismissAll();
        this.notify.error(err.error.error, {timeout: 3000, showProgressBar: false });
      }
    );
  }

}
